// src/components/section-templates/SectionMediaRight.jsx
import React from "react";
import { MotionContainer, MotionItem } from "../../animations/MotionWrappers";
import "./SectionMediaRight.css"; // only for layout-specific styling

const DEFAULT_TITLE = "40% Faster Delivery with Animation System";
const DEFAULT_TEXT = `I built a reusable animation library and a set of how-to templates
that standardize our video creation process. This toolkit cuts 3-4
hours of work per project and drives a measurable boost in overall
production efficiency.`;
const DEFAULT_IMAGE = {
  src: "../assets/Images/Portfolio/work-at-thinkmarkets/iphone-animation-transperent.gif",
  alt: "iphone-animation",
};

export default function SectionMediaRight({
  title = DEFAULT_TITLE,
  text = DEFAULT_TEXT,
  imageSrc = DEFAULT_IMAGE.src,
  imageAlt = DEFAULT_IMAGE.alt,
  // optional overrides for this section’s stagger
  delayChildren = 0.2,
  staggerChildren = 0.2,
}) {
  return (
    <MotionContainer
      className="container pg-container"
      delayChildren={delayChildren}
      staggerChildren={staggerChildren}
    >
      <MotionItem className="pg-text">
        <h2>{title}</h2>
        <p>{text}</p>
      </MotionItem>

      <MotionItem className="pg-media">
        <img className="pg-image" src={imageSrc} alt={imageAlt} />
      </MotionItem>
    </MotionContainer>
  );
}
